import { render, staticRenderFns } from "./PromoCodeScopes.vue?vue&type=template&id=ccae432e"
import script from "./PromoCodeScopes.vue?vue&type=script&lang=ts"
export * from "./PromoCodeScopes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports